(function() {
    angular
        .module('emarket.main.profile')
        .controller('TransactionController', ['$log', '$scope', '$state', '$mdToast', '$location', 'Transaction', 'Auth', 'Profile', 'Announcer', function($log,
            $scope,
            $state,
            $mdToast,
            $location,
            Transaction,
            Auth,
            Profile,
            Announcer) {
            var vm = this;
            var user = Auth.getUser();
            var transactionResponse = $location.search();
            var announcer = Announcer.create($scope);
            Transaction.getByOrderNumber(transactionResponse.orderNumber).then(function(transaction) {
                if (transaction.status === 'approved') {
                    Profile.$find(user._id)
                        .$asPromise()
                        .then(function(user) {
                            Auth.setUser(user);
                            announcer.emit(Auth.USER_CHANGE);
                            $mdToast.show($mdToast.simple().textContent('Balance agregado satisfactoriamente'));
                            $state.go('main.plan', { location: 'replace' });
                        });
                }
            });
            vm.loading = true;
        }]);
}());
